import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NitroLoading } from 'nitro-components';

const LoadingContainer = styled.div`
  position: relative;
`;

const ActionText = styled.p`
  cursor: ${props => (props.disabled ? 'initial' : 'pointer')};
  text-transform: initial;
  color: ${props =>
    props.disabled
      ? props.theme.color.lightGreyBlue
      : props.theme.color.negative};
`;

const CancelFuelCard = ({ disabled, loading, onClick }) => {
  if (loading) {
    return (
      <LoadingContainer>
        <NitroLoading size={20} />
      </LoadingContainer>
    );
  }

  return (
    <ActionText
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}>
      Cancel Card
    </ActionText>
  );
};

CancelFuelCard.defaultProps = {
  disabled: false,
  loading: false,
  onClick: () => {}
};

CancelFuelCard.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func
};

export default CancelFuelCard;



// WEBPACK FOOTER //
// ./src/features/fuel-cards/cancel-fuel-card.js